AppTabs.createTab( {
	name: 'import-settings',
	icon: 'upload',
	text: 'Import Settings',
	create: function(init) {
		'use strict'

		init.setDataTableArgs( {

			tableId: 		'#data-table-import-settings',

			readTableName: 	'tblImportSettings',
			editTableName: 	'tblImportSettings',
			primaryKey: 	'ImportID',

			paging:			false,

			actionData:			'datatable',
			actionCreate:		'datatable_create',
			actionEdit:			'datatable_edit',
			actionRemove:		'datatable_remove',

			fields: [
				{
					label: 		'Name',
					columnName: 'ImportName',
					isEditable: true,
				},
				{
					label: 		'Test Name',
					columnName: 'ImportTestID',
					isEditable: true,
					type:		'maybe-test',
					render: 	DataTablesManager.getTestNameByID,
				},
				{
					label: 		'Sample # Field',
					columnName: 'ImportSampleNumberField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Strip Sample #',
					columnName: 'ImportStripSampleNumber',
					isEditable: true,
					type:		'boolean',
				},
				{
					label: 		'Numeric Result Field',
					columnName: 'ImportNumericResultField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Result Field',
					columnName: 'ImportResultField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'< Field',
					columnName: 'ImportLessThanField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Flags Field',
					columnName: 'ImportFlagsField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'LOD Field',
					columnName: 'ImportLODField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'LOQ Field',
					columnName: 'ImportLOQField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Dilution Field',
					columnName: 'ImportDilutionField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Units Field',
					columnName: 'ImportUnitsField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Date Analyzed Field',
					columnName: 'ImportDateAnalyzedField',
					isEditable: true,
					type:		'columnLetter',
				},
				/*{
					label: 		'Analyst Field',
					columnName: 'ImportAnalystField',
					isEditable: true,
					type:		'columnLetter',
				},*/
				{
					label: 		'Parameter Field',
					columnName: 'ImportParameterField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Test Field',
					columnName: 'ImportTestField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Analyte Field',
					columnName: 'ImportAnalyteField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Method Field',
					columnName: 'ImportMethodField',
					isEditable: true,
					type:		'columnLetter',
				},
				{
					label: 		'Decimal Places',
					columnName: 'ImportDecimalPlaces',
					isEditable: true,
				},
				{
					label: 		'Units',
					columnName: 'ImportUnits',
					isEditable: true,
					type: 		'combobox',
					datalist: 	'units',
				},

			],

		} );
	}
} );
